export function getNodeStatusStyles(statusRaw: string | null | undefined): {
  container: string;
  badge: string;
  ring: string;
} {
  const s = String(statusRaw ?? 'PENDING').trim().toUpperCase();

  if (s === 'DISCARDED' || s === 'SKIPPED' || s === 'DISABLED') {
    return {
      container: 'border-neutral-700 pac-glass-subtle',
      badge: 'border-neutral-700 text-neutral-700 bg-neutral-950',
      ring: 'ring-neutral-900/70',
    };
  }

  if (s === 'SUCCEEDED' || s === 'SUCCESS' || s === 'DONE' || s === 'COMPLETED') {
    return {
      container: 'border-emerald-600/70 pac-glass-subtle',
      badge: 'border-emerald-700/60 text-emerald-200 bg-emerald-950/40',
      ring: 'ring-emerald-400/60',
    };
  }

  if (s === 'RUNNING' || s === 'IN_PROGRESS' || s === 'STARTED') {
    return {
      container: 'border-emerald-500/70 pac-glass-subtle',
      badge: 'border-emerald-700/60 text-emerald-200 pac-glass',
      ring: 'ring-emerald-400/60',
    };
  }

  if (s === 'FAILED' || s === 'ERROR' || s === 'CANCELED' || s === 'CANCELLED') {
    return {
      container: 'border-rose-600/70 pac-glass-subtle',
      badge: 'border-rose-700/60 text-rose-200 bg-rose-950/40',
      ring: 'ring-rose-400/60',
    };
  }

  return {
    container: 'border-neutral-700 pac-glass-subtle hover:border-neutral-500',
    badge: 'border-neutral-700 text-neutral-300 pac-glass',
    ring: 'ring-neutral-500/60',
  };
}
